export * from './product-detail-section-header';
